import { slugify } from '@prishapolicy/shared/ui';
import { useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const H2 = ({ children }: { children: string }) => {
  const h2Ref = useRef<HTMLHeadingElement>(null);
  // const context = useContext(ProductWriteUpContext);
  // useEffect(() => {
  //   const handleScroll = function () {
  //     // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  //     const position = h1Ref.current!.getBoundingClientRect();

  //     // checking whether fully visible
  //     // if (position.top >= 0 && position.bottom <= window.innerHeight) {
  //       // context?.setActiveSection('#' + slugify(children));
  //     // }

  //     // // checking for partial visibility
  //     // if (position.top < window.innerHeight && position.bottom >= 0) {
  //     //   console.log('Element is partially visible in screen');
  //     // }
  //   };
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // });
  return (
    <h2
      id={slugify(children)}
      ref={h2Ref}
      className={`text-title-4 font-bold`}
      style={
        {
          // paddingTop: isLg ? 100 : 160,
          // marginTop: isLg ? -80 : -40,
        }
      }
    >
      {children}
    </h2>
  );
};

export default H2;
